<template>
  <v-card ripple class="list_card" @click="openProject">
    <v-card-title primary-title>
      <div style='width:100%;'>
        <h3 class="headline mb-0">{{ name }}</h3>
        <p>{{ shorten_description }}</p>
      </div>
    </v-card-title>
  </v-card>
</template>
<script>
export default {
  name: "Project",
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  },
  computed: {
    shorten_description(){
      if (this.description.length > 50) {
        return this.description.substring(0, 50) + "...";
      }
      return this.description;
    }
  },
  methods: {
    openProject(){
      this.$router.push("project/" + this.id);
    }
  }
}
</script>
<style>
.v-card{
  cursor: pointer;
}
</style>
